import { useCallback, useEffect, useRef } from 'react';

import { createConsumer } from '@rails/actioncable';

import type { Consumer, Subscription } from './types';

export function useSubscription() {
  const consumerRef = useRef<Consumer | null>(null);
  const subscriptionRef = useRef<Subscription | null>(null);

  const unsubscribe = useCallback(() => {
    subscriptionRef.current?.unsubscribe();
    subscriptionRef.current = null;
    consumerRef.current?.disconnect();
    consumerRef.current = null;
  }, []);

  useEffect(() => unsubscribe, [unsubscribe]);

  const subscribe = useCallback((params: object, handlers: object) => {
    unsubscribe();
    consumerRef.current = createConsumer() as Consumer;
    subscriptionRef.current = consumerRef.current.subscriptions.create(params, handlers);
  }, [unsubscribe]);

  return { subscribe, unsubscribe };
}
